export default __webpack_public_path__ + "static/media/icon-search.02d02304.svg";